import React from 'react';
import styled from '@emotion/native';
import { Title } from './styledComponents';
import useExploreStore from '@/stores/useExploreStore';
import PriceTierOption from './PriceTierOption';
import { AGE_OPTIONS } from '@/shared/constants/instantCall';
import { AgeRange } from '@/shared/types/generated';

const AgePreferenceFilter = () => {
  const { filters, setFilters } = useExploreStore();
  const selected = filters.age;

  function handleSelect(value: AgeRange) {
    const newAges = selected.includes(value)
      ? selected.filter((age) => age !== value)
      : [...selected, value];

    setFilters({ age: newAges });
  }

  return (
    <Container>
      <Title>Filter by Age Preference:</Title>
      {AGE_OPTIONS.map((option) => {
        if (option.value === AgeRange.NoPreference) {
          return null;
        }
        return (
          <Row key={option.label}>
            <PriceTierOption
              title={option.label}
              isSelected={selected.includes(option.value)}
              onPress={() => handleSelect(option.value)}
            />
          </Row>
        );
      })}
      <PriceTierOption
        title="SHOW ALL"
        isSelected={selected.length === 0}
        onPress={() => setFilters({ age: [] })}
      />
    </Container>
  );
};

const Container = styled.View({
  marginBottom: 32,
});

const Row = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
});

export default AgePreferenceFilter;
